import { createSlice } from "@reduxjs/toolkit";
import {
    getAllAttendances, getAllUsersAttendances, getAllEmployeeAttendance, getEmployeeAttendanceByMonth, getSalesEntries, getAllSalesAttendances,
    getAllUsersWithSalesData, createCheckIn, createCheckOut, getTodaysAttendance, approveOvertime, getEmployeeAttendanceByID, getTravelPathData, getUserRoutes,
    getPendingApprovals, getApprovalStatistics, approveFaceRegistration, rejectFaceRegistration, deleteFaceRegistration, submitFaceRegistration,
    getLeavesForAttendance, getPendingAttendanceApprovals, getApprovedAttendanceApprovals, getRejectedAttendanceApprovals, getAttendanceApprovalStatistics, handleApprovalAction, getMyPendingApprovals
} from './thunk';

export const initialState = {
    empAttendanceList: [],
    empMainUpdates: [],
    salesAttendanceList: [],
    visitDataList: [],
    usersWithSalesData: [],
    travelPathData: null,
    userRoutes: [],
    userRoutesLoading: false,
    // Traditional attendance state
    todaysAttendance: [],
    loading: false,
    employeeDetailLoading: false,
    errors: {},
    // Leaves data for attendance
    leavesData: [],
    leavesLoading: false,
    // Facial Recognition Approval state
    pendingApprovals: [],
    approvalStatistics: {
        pending_count: 0,
        approved_today: 0,
        rejected_today: 0
    },
    isApprovalLoading: false,
    // Attendance Approval state
    pendingAttendanceApprovals: [],
    approvedAttendanceApprovals: [],
    rejectedAttendanceApprovals: [],
    attendanceApprovalStatistics: null,
    myPendingApprovals: []
};

const UsersSlice = createSlice({
    name: 'EmpAttendance',
    initialState,
    reducers: {
        clearActiveSession: (state: any) => {
            state.activeSession = null;
        },
        clearDailySessions: (state: any) => {
            state.dailySessions = [];
            state.totalDailyHours = "00:00:00";
            state.totalHoursDecimal = 0;
        }
    },
    extraReducers: (builder) => {
        // List
        builder.addCase(getAllAttendances.pending, (state: any) => {
            state.loading = true;
        });
        builder.addCase(getAllAttendances.fulfilled, (state: any, action: any) => {
            state.empAttendanceList = action.payload;
            state.loading = false;
        });
        builder.addCase(getAllAttendances.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || null;
            state.loading = false;
        });

        // All Users Attendance
        builder.addCase(getAllUsersAttendances.pending, (state: any) => {
            state.loading = true;
        });
        builder.addCase(getAllUsersAttendances.fulfilled, (state: any, action: any) => {
            state.empAttendanceList = action.payload;
            state.loading = false;
        });
        builder.addCase(getAllUsersAttendances.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || null;
            state.loading = false;
        });
        builder.addCase(getAllEmployeeAttendance.pending, (state: any) => {
            state.loading = true;
        });
        builder.addCase(getAllEmployeeAttendance.fulfilled, (state: any, action: any) => {
            state.empAttendanceList = action.payload;
            state.loading = false;
        });
        builder.addCase(getAllEmployeeAttendance.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || null;
            state.loading = false;
        });

        // Employee month attendance
        builder.addCase(getEmployeeAttendanceByMonth.pending, (state: any) => {
            state.loading = true;
        });
        builder.addCase(getEmployeeAttendanceByMonth.fulfilled, (state: any, action: any) => {
            state.empAttendanceList = action.payload;
            state.loading = false;
        });
        builder.addCase(getEmployeeAttendanceByMonth.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || null;
            state.loading = false;
        });
        
        // Employee detail loading
        builder.addCase(getEmployeeAttendanceByID.pending, (state: any) => {
            state.employeeDetailLoading = true;
        });
        builder.addCase(getEmployeeAttendanceByID.fulfilled, (state: any, action: any) => {
            state.employeeDetailLoading = false;
        });
        builder.addCase(getEmployeeAttendanceByID.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || null;
            state.employeeDetailLoading = false;
        });
        
        builder.addCase(getSalesEntries.fulfilled, (state: any, action: any) => {
            state.visitDataList = action.payload;
        });
        builder.addCase(getSalesEntries.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || null;
        });
        builder.addCase(getAllSalesAttendances.fulfilled, (state: any, action: any) => {
            state.salesAttendanceList = action.payload;
        });
        builder.addCase(getAllSalesAttendances.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || null;
        });

        // Users with sales data
        builder.addCase(getAllUsersWithSalesData.fulfilled, (state: any, action: any) => {
            state.usersWithSalesData = action.payload;
        });
        builder.addCase(getAllUsersWithSalesData.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || null;
        });

        // Travel path data
        builder.addCase(getTravelPathData.fulfilled, (state: any, action: any) => {
            state.travelPathData = action.payload;
        });
        builder.addCase(getTravelPathData.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || null;
        });

        // User routes data
        builder.addCase(getUserRoutes.pending, (state: any) => {
            state.userRoutesLoading = true;
        });
        builder.addCase(getUserRoutes.fulfilled, (state: any, action: any) => {
            state.userRoutes = action.payload;
            state.userRoutesLoading = false;
        });
        builder.addCase(getUserRoutes.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || null;
            state.userRoutesLoading = false;
        });

        // Traditional attendance reducers
        builder.addCase(createCheckIn.fulfilled, (state: any, action: any) => {
            if (action.payload && action.payload.status) {
                // Refresh today's attendance after check-in
                // The component will handle this
            }
        });
        builder.addCase(createCheckIn.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || null;
        });

        builder.addCase(createCheckOut.fulfilled, (state: any, action: any) => {
            if (action.payload && action.payload.status) {
                // Refresh today's attendance after check-out
                // The component will handle this
            }
        });
        builder.addCase(createCheckOut.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || null;
        });

        builder.addCase(getTodaysAttendance.fulfilled, (state: any, action: any) => {
            if (action.payload && action.payload.status) {
                state.todaysAttendance = action.payload.data;
            } else {
                state.todaysAttendance = [];
            }
        });
        builder.addCase(getTodaysAttendance.rejected, (state: any, action: any) => {
            state.todaysAttendance = [];
            state.error = action.payload?.error || null;
        });

        builder.addCase(approveOvertime.fulfilled, (state: any, action: any) => {
            // Refresh attendance list after overtime approval
            // This will be handled by the component
        });
        builder.addCase(approveOvertime.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || null;
        });

        // Leaves data reducers
        builder.addCase(getLeavesForAttendance.pending, (state: any) => {
            state.leavesLoading = true;
        });
        builder.addCase(getLeavesForAttendance.fulfilled, (state: any, action: any) => {
            state.leavesLoading = false;
            state.leavesData = action.payload.data || [];
        });
        builder.addCase(getLeavesForAttendance.rejected, (state: any, action: any) => {
            state.leavesLoading = false;
            state.error = action.payload?.error || null;
        });

        // Facial Recognition Approval Reducers
        builder.addCase(getPendingApprovals.pending, (state: any) => {
            state.isApprovalLoading = true;
        });
        builder.addCase(getPendingApprovals.fulfilled, (state: any, action: any) => {
            state.isApprovalLoading = false;
            if (action.payload?.status) {
                state.pendingApprovals = action.payload.data || [];
            } else {
                state.pendingApprovals = [];
            }
        });
        builder.addCase(getPendingApprovals.rejected, (state: any) => {
            state.isApprovalLoading = false;
        });
        
        builder.addCase(getApprovalStatistics.pending, (state: any) => {
            state.isApprovalLoading = true;
        });
        builder.addCase(getApprovalStatistics.fulfilled, (state: any, action: any) => {
            state.isApprovalLoading = false;
            if (action.payload?.status) {
                state.approvalStatistics = action.payload.data || {
                    pending_count: 0,
                    approved_today: 0,
                    rejected_today: 0
                };
            } else {
                state.approvalStatistics = {
                    pending_count: 0,
                    approved_today: 0,
                    rejected_today: 0
                };
            }
        });
        builder.addCase(getApprovalStatistics.rejected, (state: any) => {
            state.isApprovalLoading = false;
        });
        
        builder.addCase(approveFaceRegistration.fulfilled, (state: any, action: any) => {
            if (action.payload?.status) {
                const approvedId = action.payload.data?.id;
                state.pendingApprovals = state.pendingApprovals.filter(
                    (approval: any) => approval.id !== approvedId
                );
                // Update statistics
                state.approvalStatistics.approved_today += 1;
            }
        });
        
        builder.addCase(rejectFaceRegistration.fulfilled, (state: any, action: any) => {
            if (action.payload?.status) {
                const rejectedId = action.payload.data?.id;
                state.pendingApprovals = state.pendingApprovals.filter(
                    (approval: any) => approval.id !== rejectedId
                );
                // Update statistics
                state.approvalStatistics.rejected_today += 1;
            }
        });
        
        builder.addCase(deleteFaceRegistration.fulfilled, (state: any, action: any) => {
            if (action.payload?.status) {
                const deletedId = action.payload.data?.id;
                state.pendingApprovals = state.pendingApprovals.filter(
                    (approval: any) => approval.id !== deletedId
                );
                // Update statistics - reduce pending count
                state.approvalStatistics.pending_count = Math.max(0, state.approvalStatistics.pending_count - 1);
            }
        });

        // Attendance Approval Reducers
        builder.addCase(getPendingAttendanceApprovals.pending, (state: any) => {
            state.loading = true;
        });
        builder.addCase(getPendingAttendanceApprovals.fulfilled, (state: any, action: any) => {
            state.loading = false;
            if (action.payload?.status) {
                state.pendingAttendanceApprovals = action.payload.data || [];
            } else {
                state.pendingAttendanceApprovals = [];
            }
        });
            builder.addCase(getPendingAttendanceApprovals.rejected, (state: any) => {
        state.loading = false;
    });

    builder.addCase(getApprovedAttendanceApprovals.pending, (state: any) => {
        state.loading = true;
    });

    builder.addCase(getApprovedAttendanceApprovals.fulfilled, (state: any, action: any) => {
        state.loading = false;
        // Ensure we always store an array for consumers
        state.approvedAttendanceApprovals = Array.isArray(action.payload)
            ? action.payload
            : (action.payload?.data && Array.isArray(action.payload.data))
                ? action.payload.data
                : [];
    });

    builder.addCase(getApprovedAttendanceApprovals.rejected, (state: any) => {
        state.loading = false;
    });

    builder.addCase(getRejectedAttendanceApprovals.pending, (state: any) => {
        state.loading = true;
    });

    builder.addCase(getRejectedAttendanceApprovals.fulfilled, (state: any, action: any) => {
        state.loading = false;
        // Ensure we always store an array for consumers
        state.rejectedAttendanceApprovals = Array.isArray(action.payload)
            ? action.payload
            : (action.payload?.data && Array.isArray(action.payload.data))
                ? action.payload.data
                : [];
    });

    builder.addCase(getRejectedAttendanceApprovals.rejected, (state: any) => {
        state.loading = false;
    });

    builder.addCase(getAttendanceApprovalStatistics.pending, (state: any) => {
            state.loading = true;
        });
        builder.addCase(getAttendanceApprovalStatistics.fulfilled, (state: any, action: any) => {
            state.loading = false;
            if (action.payload?.status) {
                state.attendanceApprovalStatistics = action.payload.data || null;
            } else {
                state.attendanceApprovalStatistics = null;
            }
        });
        builder.addCase(getAttendanceApprovalStatistics.rejected, (state: any) => {
            state.loading = false;
        });

        builder.addCase(handleApprovalAction.fulfilled, (state: any, action: any) => {
            if (action.payload?.status) {
                const processedId = action.payload.data?.id;
                state.pendingAttendanceApprovals = state.pendingAttendanceApprovals.filter(
                    (approval: any) => approval.id !== processedId
                );
                // Refresh statistics
                // The component will call getAttendanceApprovalStatistics to refresh
            }
        });

        builder.addCase(getMyPendingApprovals.pending, (state: any) => {
            state.loading = true;
        });
        builder.addCase(getMyPendingApprovals.fulfilled, (state: any, action: any) => {
            state.loading = false;
            if (action.payload?.status) {
                state.myPendingApprovals = action.payload.data || [];
            } else {
                state.myPendingApprovals = [];
            }
        });
        builder.addCase(getMyPendingApprovals.rejected, (state: any) => {
            state.loading = false;
        });
    }
});

export default UsersSlice.reducer;